module.exports = __webpack_public_path__ + "img/features-split-image-02.a237a8a6.jpg";